import * as firebase from "firebase/app";
import "firebase/remote-config";

// staging
const firebaseConfig = {
  apiKey: "AIzaSyCF4unl-_3pkxc8MwAZMlDz4O3u6gDGr0s",
  authDomain: "ihrmeet-test.firebaseapp.com",
  databaseURL: "https://ihrmeet-test.firebaseio.com",
  projectId: "ihrmeet-test",
  storageBucket: "ihrmeet-test.appspot.com",
  messagingSenderId: "623541211033",
  appId: "1:623541211033:web:e595f478bc3f8a86430d08",
  measurementId: "G-71PTPX4711"
};

// live
// const firebaseConfig = {
//   apiKey: "AIzaSyBDyAFVNrWD3V9ukO3k3FkH4ll3tnpZPxQ",
//   authDomain: "ihrmeet.firebaseapp.com",
//   databaseURL: "https://ihrmeet.firebaseio.com",
//   projectId: "ihrmeet",
//   storageBucket: "ihrmeet.appspot.com",
//   messagingSenderId: "987017020062",
//   appId: "1:987017020062:web:e1724ab50bac356eb2318f"
// };

export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const remoteConfig = firebaseApp.remoteConfig();
remoteConfig.settings = {
  fetchTimeoutMillis: 60000,
  minimumFetchIntervalMillis: 1000,
};

remoteConfig.defaultConfig = {
  is_check: true,
  is_check_sms: false,
};
